// import ApiService from '@/services/api.services'
import ApiService from '../api.service'
import { TokenService } from '@/services/storage.service'

const ItemPromotionService = {
    searchItemPromotionAdvanced: async (payload) => {
        const url = `/api/ItemPromotion/searchItemPromotionAdvanced`

        const requestData = {
            method: 'post',
            url: url,
            data: payload,
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },
    saveItemPromotion: async (payload) => {
        const url = `/api/ItemPromotion/saveItemPromotion`

        const requestData = {
            method: 'post',
            url: url,
            data: payload,
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },
}

export default ItemPromotionService